import { Form, Formik } from "formik";

import { Clinic } from "pwapi";

import { updateIntegrations } from "shared/actions/admin/adminCaseActions";
import useClinicFields, {
  objectStructureForEMRFields,
  useIntegrationValues,
} from "shared/hooks/useClinicFields";
import { integrationSchema } from "shared/utils/caseSchema";

import { useAppDispatch } from "app/hooks";
import { CaseState } from "app/reducers/admin/reducers/caseReducer";
import { PatientState } from "app/reducers/admin/reducers/patientReducer";
import BaseIntegrationsForm from "ui/CaseForms/IntegrationsForm";

const IntegrationsForm = ({
  caseDetail,
  patient,
}: {
  // TODO: followed `CaseDetailsForm` on these types, but they are wrong
  // (I think). Fix these types to CaseAdmin types
  caseDetail?: CaseState;
  patient: PatientState;
}) => {
  const orderingDoctor = caseDetail?.ordering_doctor;
  const supervisingPhysician = caseDetail?.supervising_physician;
  const clinic = patient?.clinic;
  const caseId = caseDetail?.id;
  const dispatch = useAppDispatch();

  // NOTE that "nested" (non-flat) comes _in_ to the form...
  const integrationValues = useIntegrationValues({
    adminCaseOrValues: { ...caseDetail, patient },
    skipMRN: true,
  });

  const initialValues = {
    ...integrationValues,
    clinic: clinic || undefined,
    ordering_doctor: orderingDoctor || undefined,
    ordering_doctor_id: orderingDoctor?.id,
    supervising_physician: supervisingPhysician || undefined,
    supervising_physician_id: supervisingPhysician?.id,
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values: typeof initialValues) => {
        const integrationValues = useIntegrationValues({
          adminCaseOrValues: values,
          skipMRN: true,
          // ... but "flat" goes out into the `clinic-integration` endpoint
          flatIntegration: true,
        });
        caseId &&
          patient?.id &&
          values.clinic?.id &&
          values.ordering_doctor?.id &&
          dispatch(
            updateIntegrations({
              ...integrationValues,
              clinic_id: values.clinic.id,
              ordering_doctor_id: values.ordering_doctor.id,
              supervising_physician_id: values.supervising_physician?.id,
              case_id: caseId,
            })
          );
      }}
      validateOnBlur={false}
      validationSchema={integrationSchema}
      validateOnMount={true}
    >
      {({ dirty, errors, setTouched, setValues, touched, values }) => {
        return (
          <Form autoComplete="off">
            <BaseIntegrationsForm
              displaySubmit
              dirty={dirty}
              onChangeClinic={(value: Clinic) => {
                const emr = useClinicFields({
                  clinic: value,
                  ordering_doctor_id: values.ordering_doctor?.id,
                  flatIntegration: true,
                  skipMRN: true,
                });
                const blankEMRFields = objectStructureForEMRFields(emr, null);
                setValues({
                  ...values,
                  clinic: value,
                  ...blankEMRFields,
                });
              }}
              clearValues={() => {
                // Clear all values and touch states
                setTouched({});
                setValues(
                  Object.fromEntries(
                    Object.entries(values).map((k) => [k, null])
                  )
                );
              }}
              values={values}
              errors={errors}
              touched={touched}
              flatIntegration={true}
              skipMRN={true}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default IntegrationsForm;
